import React from 'react'

const CalendarIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="calendarGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 220, 1)" />
        </linearGradient>
        <filter id="calendarGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Calendar body */}
      <rect 
        x="4" 
        y="5" 
        width="16" 
        height="16" 
        rx="2"
        stroke="url(#calendarGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#calendarGlow)"
      />
      
      {/* Top bar */}
      <line 
        x1="4" 
        y1="9" 
        x2="20" 
        y2="9" 
        stroke="url(#calendarGradient)"
        strokeWidth="2"
      />
      
      {/* Calendar hooks */}
      <line 
        x1="8" 
        y1="3" 
        x2="8" 
        y2="7" 
        stroke="url(#calendarGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line 
        x1="16" 
        y1="3" 
        x2="16" 
        y2="7" 
        stroke="url(#calendarGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Date dots */}
      <circle cx="9" cy="14" r="1" fill="url(#calendarGradient)"/>
      <circle cx="12" cy="14" r="1" fill="url(#calendarGradient)"/>
      <circle cx="15" cy="14" r="1" fill="url(#calendarGradient)"/>
      <circle cx="9" cy="17" r="1" fill="url(#calendarGradient)"/>
      <circle cx="12" cy="17" r="1" fill="url(#calendarGradient)"/>
    </svg>
  )
}

export default CalendarIcon
